import type { InternalAxiosRequestConfig } from 'axios';

/**
 * WEB-971 — «Загрузить с компьютера» падал 400 «Файл не передан».
 *
 * Клиент ставит дефолтный Content-Type: application/json на весь инстанс, и
 * FormData-запросы уходили с json-типом БЕЗ multipart-границы — multer на
 * бэке не видел ни одной файловой части. Интерцептор снимает заголовок для
 * FormData: без него браузер сам выставит multipart/form-data; boundary=…
 *
 * Модуль отдельный (а не в client.ts) намеренно: client.ts тянет import.meta
 * и не импортируется в jest напрямую — а этот шов обязан быть под тестом
 * (client.formData.web971.test.ts).
 */
export function stripJsonContentTypeForFormData(
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig {
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }
  return config;
}
